import { getAuthState } from '../hooks/useAuth';

let auth = getAuthState()

export const apGetEnrichment = async (id_enriquecimento: string): Promise<Array<object>> => {
    try {

        if (!id_enriquecimento) return [];
        auth = getAuthState()
        const response = await fetch(`https://f5gkmqm2yh.execute-api.us-east-1.amazonaws.com/prod/ap/enrichment?id_enriquecimento=${id_enriquecimento}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': auth.idToken
            }
        });

        const data = await response.json();
        return JSON.parse(data.body);
    } catch (error) {
        console.error('Error fetching files:', error);
        return [];
    }
};